module.exports = __webpack_public_path__ + "img/bdf3873b77b84aaf932d22fd54e4dfaf.51f9a455.jpg";